<template>
    <DCard
        padding
    >
        <Form
            :country="country"
            :errors="errors"
            :currency-codes="currencyCodes"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/Countries/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    country: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    currencyCodes: {
        type: Array,
        default: () => []
    }
})

const submitData = (form) => {
    form.put(route('settings.countries.update', props.country.country_code))
}
</script>
